// extracted by mini-css-extract-plugin
export var checkbox = "CheckboxGroup-module--checkbox--cd840";
export var checkboxItem = "CheckboxGroup-module--checkboxItem--babc6 formElements-module--label--5dd53";
export var checkboxTick = "CheckboxGroup-module--checkboxTick--a3a0a";
export var checkedIcon = "CheckboxGroup-module--checkedIcon--d0247";
export var firstItem = "CheckboxGroup-module--firstItem--249b7";
export var lastStepCheckboxGroup = "CheckboxGroup-module--lastStepCheckboxGroup--f34f9";